var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientMonitoringIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2868_47651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 7C1 3.13401 4.13401 0 8 0H42C45.866 0 49 3.13401 49 7V41C49 44.866 45.866 48 42 48H8C4.13401 48 1 44.866 1 41V7Z",
    fill: "#FEF2CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 14H18C18.2833 14 18.5208 14.0958 18.7125 14.2875C18.9042 14.4792 19 14.7167 19 15V34C18.45 34 17.9792 33.8042 17.5875 33.4125C17.1958 33.0208 17 32.55 17 32V16H16C15.7167 16 15.4792 15.9042 15.2875 15.7125C15.0958 15.5208 15 15.2833 15 15C15 14.7167 15.0958 14.4792 15.2875 14.2875C15.4792 14.0958 15.7167 14 16 14ZM22 34C21.45 34 20.9792 33.8042 20.5875 33.4125C20.1958 33.0208 20 32.55 20 32V16C20 15.45 20.1958 14.9792 20.5875 14.5875C20.9792 14.1958 21.45 14 22 14H31C31.55 14 32.0208 14.1958 32.4125 14.5875C32.8042 14.9792 33 15.45 33 16V32C33 32.55 32.8042 33.0208 32.4125 33.4125C32.0208 33.8042 31.55 34 31 34H22ZM22 22.525C22.3 22.3417 22.6167 22.2083 22.95 22.125C23.2833 22.0417 23.6333 22 24 22H29C29.3667 22 29.7167 22.0417 30.05 22.125C30.3833 22.2083 30.7 22.3417 31 22.525V16H22V22.525ZM26.5 21C25.95 21 25.4792 20.8042 25.0875 20.4125C24.6958 20.0208 24.5 19.55 24.5 19C24.5 18.45 24.6958 17.9792 25.0875 17.5875C25.4792 17.1958 25.95 17 26.5 17C27.05 17 27.5208 17.1958 27.9125 17.5875C28.3042 17.9792 28.5 18.45 28.5 19C28.5 19.55 28.3042 20.0208 27.9125 20.4125C27.5208 20.8042 27.05 21 26.5 21ZM25.5 31H27.5V29H29.5V27H27.5V25H25.5V27H23.5V29H25.5V31Z",
    fill: "#F6B804"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2868_47651",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2868_47651"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2868_47651",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientMonitoringIcon);
export default __webpack_public_path__ + "static/media/patient-monitoring-icon.002356fb66852e6ae85cf8868dbe381d.svg";
export { ForwardRef as ReactComponent };